import React from 'react';
import PropTypes from 'prop-types';

import DeviceStatistics from '../deviceStatistics/deviceStatistics';

import styles from './deviceUptimeCharts.module.scss';

const DeviceUptimeChartsRow = ({ deviceStatistics = [] }) => (
  <div className={styles.deviceChartsInner}>
    {deviceStatistics.map((device, index) => (
      <DeviceStatistics
        key={index}
        title={device.title}
        subTitle={device.subTitle}
        chartData={device.chartData}
        chartLabel={device.chartLabel}
        faultyDeviceIds={device.faultyDeviceIds}
      />
    ))}
  </div>
);

DeviceUptimeChartsRow.propTypes = {
  deviceStatistics: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subTitle: PropTypes.string.isRequired,
      chartData: PropTypes.array.isRequired,
      chartLabel: PropTypes.string,
      faultyDeviceIds: PropTypes.arrayOf(PropTypes.number),
    })
  ).isRequired,
};

export default DeviceUptimeChartsRow;
